import React from 'react';
import { withTranslation } from 'react-i18next';

class AboutDataProtection extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <div className="dp-section dp-cream mobile-page-padding">
                <div className="container">
                    <div className="dp-intro-grid">
                        {/* Visual minimalista de línea (base de datos) */}
                        <div className="dp-figure">
                            <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
                                <ellipse cx="32" cy="16" rx="18" ry="7" />
                                <path d="M14 16 v32 c0 3.9 8.06 7 18 7 s18 -3.1 18 -7 V16" />
                                <path d="M14 32 c0 3.9 8.06 7 18 7 s18 -3.1 18 -7" />
                            </svg>
                        </div>
                        {/* Texto */}
                        <div className="dp-intro-content">
                            <p className="dp-eyebrow">{t('pages.dataProtection.banner.pagename')}</p>
                            <h2 className="dp-title">{t('pages.dataProtection.about.title')}</h2>
                            <div className="dp-rule" />
                            <p className="dp-text">{t('pages.dataProtection.about.paragraph')}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default withTranslation()(AboutDataProtection);
